module.exports = {"es-PY":{"echo":{"show":{"shout":"¡Todo lo que va...","placeholder":"...vuelve!"}}}}